module.exports = __webpack_public_path__ + "img/schoen_and_skate.05292a8a.jpg";